import React from 'react';
import { Skeleton, Group, Stack, Space } from '@mantine/core';

const BookingItemSkeletonLoader: React.FC = () => {
  return (
    <Stack p="md" style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)', borderRadius: 8 }} w="100%">
      {/* Top Section: Avatar and Details */}
      <Group wrap="nowrap" w="100%" justify="space-between">
        <Group>
          <Skeleton height={48} width={48} circle />
          <div>
            <Group gap={5}>
              <Skeleton height={14} width="80px" />
              <Skeleton height={14} width="50px" />
            </Group>
            <Space h={5}></Space>
            <Group gap={5}>
              <Skeleton height={10} width="20px" />
              <Skeleton height={10} width="30px" />
              <Skeleton height={10} width="30px" />
            </Group>
          </div>
        </Group>
        <Stack align="center" justify="center" gap={5}>
          <Skeleton height={30} width={30} />
          <Skeleton height={10} width={30} />
        </Stack>
      </Group>

      {/* Status Badge */}
      <Group justify="end">
        <Skeleton height={20} width={60} radius="md" />
      </Group>
    </Stack>
  );
};

export default BookingItemSkeletonLoader;